import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state:{
        coins:[]
    },
    mutations:{
        setCoins(state,payload) {
            state.coins = payload;
        }
    },
    actions:{
        getSupportCoin({commit}) {
            api.getAllSupportCoin().then(response => {
                commit('setCoins',response.data);
            })
        }
    }
}

appStore.registerModule('common',store);